export default __webpack_public_path__ + "static/1674-1f5ad778ee763e106be630acf1d9ce13.gif";